































































































































import Vue from 'vue'
import { DatePeriod } from '@/model/DatePeriod'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import moment from 'moment'
import { DatePeriodEnum, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { getColorContrast } from '@/services/get-color-contrast'
import { EmployeeResource } from '@/model/planning/EmployeeResource'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'
import { TimeRange } from '@/types'
import { FETCH_EMPLOYEE_PLAN_DETAIL } from '@/store/action-types'
import { EmployeePlanDetailPayload } from '@/types/payload'
import { GetEmployeePlanDetailResponse, WorkingHours } from '@/types/service-response'
import { EmployeePlanDetail } from '@/model/planning/EmployeePlanDetail'
import { TranslateResult } from 'vue-i18n'

interface DetailEvent {
  name: string,
  start: string,
  end: string,
  color: string,
  isReplacement: boolean
  type: string
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  positions: any
  loading: boolean
  period: DatePeriod | undefined
  events: DetailEvent[]
  containerHeight: string
  addressColorList: EmployeePlanDetail[]
  menu: boolean
  workingHours: WorkingHours | undefined
}

export default Vue.extend({
  name: 'EmployeePlanningDetailDialog',

  components: {
    ProgressCircular
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    currentPeriod: Object as () => DatePeriod,
    planningDetailData: Object as () => EmployeeResource,
    holidayList: Array as () => Array<TimeRange>
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      loading: false,
      period: undefined,
      events: [],
      containerHeight: '540px',
      addressColorList: [],
      menu: false,
      workingHours: undefined
    }
  },

  watch: {
    planningDetailData (newVal): void {
      if(newVal) {
        this.period = this.currentPeriod
        this.fetchEmployeePlanDetailList()
      }
    }
  },

  computed: {
    getPosition (): Object {
      const top : number = (window.innerHeight - 100 - 550) / 2
      const left : number = (window.innerWidth - 900) / 2
      return {top: `${top}px`, left: `${left}px`}
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getTitle (): string {
      let begin = moment(this.currentPeriod.startDate).startOf(DatePeriodEnum.Month)
      let end = moment(this.currentPeriod.endDate).endOf(DatePeriodEnum.Month)

      if(this.period) {
        begin = moment(this.period.startDate).startOf(DatePeriodEnum.Month)
        end = moment(this.period.endDate).endOf(DatePeriodEnum.Month)
      }

      let beginStr, endStr

      const beginMonth = begin.format('MMM')
      const endMonth = end.format('MMM')

      if (beginMonth === endMonth) {
        beginStr = begin.format('DD')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      } else {
        beginStr = begin.locale(this.selectedLocale).format('DD MMM')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      }
      const yearStr = end.format('YYYY')

      return `${beginStr} - ${endStr} ${yearStr}`
    },

    formattedStart (): string {
      return moment(this.currentPeriod.startDate).format('YYYY-MM-DD')
    },

    formattedEnd (): string {
      return moment(this.currentPeriod.endDate).format('YYYY-MM-DD')
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onWhatsappButtonClick (): void {
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    dragMouseDown: function (event: any) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event: any) {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      event.preventDefault()

      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      if((container.offsetTop - this.positions.movementY) > -64 && (container.offsetTop - this.positions.movementY + container.clientHeight + 64) < event.view.innerHeight) {
        container.style.top = (container.offsetTop - this.positions.movementY) + 'px'
      } else if ((container.offsetTop - this.positions.movementY) < -64) {
        container.style.top = -64 + 'px'
      } else if ((container.offsetTop - this.positions.movementY) + container.clientHeight + 64 > event.view.innerHeight) {
        container.style.top = (event.view.innerHeight - (container.clientHeight + 64)) + 'px'
      }

      if((container.offsetLeft - this.positions.movementX) > 0 && (container.offsetLeft - this.positions.movementX + container.clientWidth + 18) < event.view.innerWidth) {
        container.style.left = (container.offsetLeft - this.positions.movementX) + 'px'
      } else if((container.offsetLeft - this.positions.movementX) < 0) {
        container.style.left = 0 + 'px'
      } else if((container.offsetLeft - this.positions.movementX + container.clientWidth + 18) > event.view.innerWidth) {
        container.style.left = (event.view.innerWidth - container.clientWidth - 18) + 'px'
      }
    },

    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    },

    intervalFormat (interval: any): string {
      return interval.time
    },

    getInterval (time: string, hour: string, date: string, weekday: number): object {
      if(this.workingHours) {
        if(weekday === 1 && this.workingHours.MonStart && this.workingHours.MonEnd) {
          const start: string = moment(this.workingHours.MonStart, 'HH:mm:ss').format('HH:mm')
          const end: string = moment(this.workingHours.MonEnd, 'HH:mm:ss').format('HH:mm')
          const startDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(start)).format('YYYY-MM-DD HH:mm')
          const endDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(end)).format('YYYY-MM-DD HH:mm')
          if(moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(time)).isBetween(moment(startDate, 'YYYY-MM-DD HH:mm'), moment(endDate, 'YYYY-MM-DD HH:mm'), 'minutes', '[)')) {
            return { 'background-color': 'rgba(243,196,207,255)', 'height': '100%' }
          }
        } else if(weekday === 2 && this.workingHours.TueStart && this.workingHours.TueEnd) {
          const start: string = moment(this.workingHours.TueStart, 'HH:mm:ss').format('HH:mm')
          const end: string = moment(this.workingHours.TueEnd, 'HH:mm:ss').format('HH:mm')
          const startDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(start)).format('YYYY-MM-DD HH:mm')
          const endDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(end)).format('YYYY-MM-DD HH:mm')
          if(moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(time)).isBetween(moment(startDate, 'YYYY-MM-DD HH:mm'), moment(endDate, 'YYYY-MM-DD HH:mm'), 'minutes', '[)')) {
            return { 'background-color': 'rgba(243,196,207,255)', 'height': '100%' }
          }
        } else if(weekday === 3 && this.workingHours.WedStart && this.workingHours.WedEnd) {
          const start: string = moment(this.workingHours.WedStart, 'HH:mm:ss').format('HH:mm')
          const end: string = moment(this.workingHours.WedEnd, 'HH:mm:ss').format('HH:mm')
          const startDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(start)).format('YYYY-MM-DD HH:mm')
          const endDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(end)).format('YYYY-MM-DD HH:mm')
          if(moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(time)).isBetween(moment(startDate, 'YYYY-MM-DD HH:mm'), moment(endDate, 'YYYY-MM-DD HH:mm'), 'minutes', '[)')) {
            return { 'background-color': 'rgba(243,196,207,255)', 'height': '100%' }
          }
        } else if(weekday === 4 && this.workingHours.ThuStart && this.workingHours.ThuEnd) {
          const start: string = moment(this.workingHours.ThuStart, 'HH:mm:ss').format('HH:mm')
          const end: string = moment(this.workingHours.ThuEnd, 'HH:mm:ss').format('HH:mm')
          const startDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(start)).format('YYYY-MM-DD HH:mm')
          const endDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(end)).format('YYYY-MM-DD HH:mm')
          if(moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(time)).isBetween(moment(startDate, 'YYYY-MM-DD HH:mm'), moment(endDate, 'YYYY-MM-DD HH:mm'), 'minutes', '[)')) {
            return { 'background-color': 'rgba(243,196,207,255)', 'height': '100%' }
          }
        } else if(weekday === 5 && this.workingHours.FriStart && this.workingHours.FriEnd) {
          const start: string = moment(this.workingHours.FriStart, 'HH:mm:ss').format('HH:mm')
          const end: string = moment(this.workingHours.FriEnd, 'HH:mm:ss').format('HH:mm')
          const startDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(start)).format('YYYY-MM-DD HH:mm')
          const endDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(end)).format('YYYY-MM-DD HH:mm')
          if(moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(time)).isBetween(moment(startDate, 'YYYY-MM-DD HH:mm'), moment(endDate, 'YYYY-MM-DD HH:mm'), 'minutes', '[)')) {
            return { 'background-color': 'rgba(243,196,207,255)', 'height': '100%' }
          }
        } else if(weekday === 6 && this.workingHours.SatStart && this.workingHours.SatEnd) {
          const start: string = moment(this.workingHours.SatStart, 'HH:mm:ss').format('HH:mm')
          const end: string = moment(this.workingHours.SatEnd, 'HH:mm:ss').format('HH:mm')
          const startDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(start)).format('YYYY-MM-DD HH:mm')
          const endDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(end)).format('YYYY-MM-DD HH:mm')
          if(moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(time)).isBetween(moment(startDate, 'YYYY-MM-DD HH:mm'), moment(endDate, 'YYYY-MM-DD HH:mm'), 'minutes', '[)')) {
            return { 'background-color': 'rgba(243,196,207,255)', 'height': '100%' }
          }
        } else if(weekday === 0 && this.workingHours.SunStart && this.workingHours.SunEnd) {
          const start: string = moment(this.workingHours.SunStart, 'HH:mm:ss').format('HH:mm')
          const end: string = moment(this.workingHours.SunEnd, 'HH:mm:ss').format('HH:mm')
          const startDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(start)).format('YYYY-MM-DD HH:mm')
          const endDate: string = moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(end)).format('YYYY-MM-DD HH:mm')
          if(moment(date, 'YYYY-MM-DD HH:mm').add(moment.duration(time)).isBetween(moment(startDate, 'YYYY-MM-DD HH:mm'), moment(endDate, 'YYYY-MM-DD HH:mm'), 'minutes', '[)')) {
            return { 'background-color': 'rgba(243,196,207,255)', 'height': '100%' }
          }
        }
      } else {
        if(weekday === 6 || weekday === 0 || this.holidayList.find((item: TimeRange) => item.startDate === date)) {
          return { 'background-color': 'rgba(247,247,247,255)', 'height': '100%' }
        } else {
          return {}
        }
      }

      if(weekday === 6 || weekday === 0 || this.holidayList.find((item: TimeRange) => item.startDate === date)) {
        return { 'background-color': 'rgba(247,247,247,255)', 'height': '100%' }
      } else {
        return {}
      }
    },

    getWeekDayName (day: any): string {
      return moment(day.date, 'YYYY-MM-DD').locale(this.selectedLocale).format('dd')
    },

    getEventColor (event: DetailEvent): string {
      return event.color
    },

    getEventStyle (event: DetailEvent): object {
      if(event.isReplacement && event.type !== 'originalShift') {
        const contrastColor: string | undefined = event.color === '#ffffff' || event.color === '#fffaed' || event.color === '#fff' ? '#000' : undefined
        return { 'background-image': `repeating-linear-gradient(135deg, ${event.color}, ${event.color} 5px, ${contrastColor ? contrastColor : '#fff'} 5px, ${contrastColor ? contrastColor : '#fff'} 10px)`, 'width': '100%', 'color': 'black', 'font-weight': 'bold', 'font-size': '14px' }
      } else {
        const textColor: string = getColorContrast(event.color)
        return {'width': '100%', 'color': `${textColor}`, 'font-weight': 'bold', 'font-size': '14px'}
      }
    },

    getAddressStyle (item: EmployeePlanDetail): Object {
     if(item.isReplacement) {
       const contrastColor: string | undefined = item.addressColor === '#ffffff' || item.addressColor === '#fffaed' || item.addressColor === '#fff' ? '#000' : undefined
       return {'background-image': `repeating-linear-gradient(135deg, ${item.addressColor}, ${item.addressColor} 5px, ${contrastColor ? contrastColor : '#fff'} 5px, ${contrastColor ? contrastColor : '#fff'} 10px)`, 'color': 'black'}
     } else {
       return {'background-color': `${item.addressColor}`, 'color': `${getColorContrast(item.addressColor ? item.addressColor : '')}`}
     }
    },

    getEventColorCodeClass (event: DetailEvent): string {
      if(event.isReplacement) {
        return 'replacement-color-code'
      } else {
        return ''
      }
    },

    getColorCodeClass (item: EmployeePlanDetail): string {
      if(item.isReplacement) {
        return 'replacement-color-code'
      } else {
        return ''
      }
    },

    async fetchEmployeePlanDetailList (): Promise<void> {
      const payload: EmployeePlanDetailPayload = {
        employeeId: this.planningDetailData.id,
        date: moment(this.period!.startDate).format('YYYY/MM/DD')
      }

      try {
        const response: GetEmployeePlanDetailResponse = await this.$store.dispatch(FETCH_EMPLOYEE_PLAN_DETAIL, payload)
        if (response && !response.IsError && response.Detail) {
          this.addressColorList = EmployeePlanDetail.createFromResponse(response.Detail, this.planningDetailData.id)

          this.events = this.planningDetailData.eventList.map((item: EmployeeEvent) => {

            const foundAddress: EmployeePlanDetail | undefined = this.addressColorList.find((i: EmployeePlanDetail) => i.addressId === item.addressId)

            let eventText: string = ''
            if (item.type === 'shift' || item.type === 'floater' || item.type === 'originalShift') {
              eventText = foundAddress ? foundAddress.colorCode : ''
            } else {
              eventText = item.name ? item.name[0] : ''
            }

            let eventColor: string = ''
            if (item.status === 'inaktiv' || item.type === 'originalShift') {
              eventColor = '#D3D3D3'
            } else {
              eventColor = item.eventColor
            }

            return {
              name: eventText,
              start: moment(item.startDateOriginal).format('YYYY-MM-DD HH:mm'),
              end: moment(item.endDateOriginal).format('YYYY-MM-DD HH:mm'),
              color: eventColor,
              isReplacement: item.isReplacement,
              type: item.type
            }
          })

          let addressList = this.addressColorList.filter((item: EmployeePlanDetail) => !item.isReplacement).sort((a: EmployeePlanDetail, b: EmployeePlanDetail) => {
            if (a.colorCode && b.colorCode) {
              if (a.colorCode === b.colorCode) {
                return parseInt(a.addressNumber) - parseInt(b.addressNumber)
              } else {
                return parseInt(a.colorCode) - parseInt(b.colorCode)
              }
            } else {
              return -1
            }
          })

          let addressReplacementList = this.addressColorList.filter((item: EmployeePlanDetail) => item.isReplacement).sort((a: EmployeePlanDetail, b: EmployeePlanDetail) => {
            if (a.colorCode && b.colorCode) {
              if (a.colorCode === b.colorCode) {
                return parseInt(a.addressNumber) - parseInt(b.addressNumber)
              } else {
                return parseInt(a.colorCode) - parseInt(b.colorCode)
              }
            } else {
              return -1
            }
          })

          this.addressColorList = addressList
          addressReplacementList.forEach((item: EmployeePlanDetail) => {
            this.addressColorList.push(item)
          })

          this.menu = true

          if(response.WorkingHours) {
            this.workingHours = response.WorkingHours
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    this.period = this.currentPeriod
    this.fetchEmployeePlanDetailList()
  }
})
